import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DetalhadoTableCell from "./DetalhadoTableCell";

const headRowStyle = (color: string) => {
  return {
    top: "-1px",
    borderBottomColor: color,
  };
};

interface TableProps {
  color: string;
  rows: any;
}

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString("pt-BR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const DetalhadoTable: React.FC<TableProps> = ({ color, rows }) => {
  return (
    <TableContainer sx={{ height: "100%" }}>
      <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
        {rows.length > 0 ? (
          <>
            <TableHead>
              <TableRow>
                <TableCell
                  padding="none"
                  align="center"
                  sx={headRowStyle(color)}
                >
                  Número Passagem
                </TableCell>
                <TableCell
                  padding="none"
                  align="center"
                  sx={headRowStyle(color)}
                >
                  Data e Hora de Entrada
                </TableCell>
                <TableCell
                  padding="none"
                  align="center"
                  sx={headRowStyle(color)}
                >
                  Data e Hora da Triagem
                </TableCell>
                <TableCell
                  padding="none"
                  align="center"
                  sx={headRowStyle(color)}
                >
                  Tempo de Espera
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    padding="none"
                    align="center"
                    component="th"
                    scope="row"
                  >
                    {row.i_num_passagem}
                  </TableCell>
                  <TableCell padding="none" align="center">
                    {formatDate(row.i_data_hora_entrada)}
                  </TableCell>
                  <TableCell padding="none" align="center">
                    {formatDate(row.i_data_hora_triagem)}
                  </TableCell>
                  <DetalhadoTableCell horaEntrada={row.i_data_hora_entrada} />
                </TableRow>
              ))}
            </TableBody>
          </>
        ) : (
          <TableRow>
            <TableCell align="center" sx={{ borderBottom: "unset", pt: 0 }}>
              Nenhum paciente aguardando atendimento
            </TableCell>
          </TableRow>
        )}
      </Table>
    </TableContainer>
  );
};

export default DetalhadoTable;
